import React from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const icon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

const userIcon = new L.DivIcon({
  className: "",
  html: `<div style="background:#00BFA6;width:16px;height:16px;border-radius:50%;border:3px solid white;box-shadow:0 0 0 2px #00BFA6"></div>`,
  iconSize: [16, 16], iconAnchor: [8, 8],
});

export default function MapView({ shops = [], user, route = null, height = 320 }) {
  const points = shops.filter((s) => s.lat && s.lng);
  const center = points[0] ? [points[0].lat, points[0].lng] : user ? [user.lat, user.lng] : [5.345, -4.0];
  return (
    <div style={{ height }} data-testid="map-view">
      <MapContainer center={center} zoom={12} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {user?.lat && (
          <Marker position={[user.lat, user.lng]} icon={userIcon}>
            <Popup>Vous êtes ici</Popup>
          </Marker>
        )}
        {points.map((s, i) => (
          <Marker key={i} position={[s.lat, s.lng]} icon={icon}>
            <Popup>
              <b>{s.name}</b><br />{s.address || s.city}
              {s.distance_km != null && <><br />{s.distance_km} km</>}
            </Popup>
          </Marker>
        ))}
        {route && route.length > 1 && (
          <Polyline positions={route} pathOptions={{ color: "#FF6B00", weight: 5, opacity: 0.8 }} />
        )}
      </MapContainer>
    </div>
  );
}
